import atencion from '../fixtures/atencion.json';
import controles from '../fixtures/controles.json';
import estado from '../fixtures/estado.json';
import historia from '../fixtures/historia.json';
import metricas from '../fixtures/metricas.json';

// Where the demo reads from.
//
// BY DEFAULT, THE FIXTURES: the five files that `mastermind_core-final`
// publishes under docs/contracts/dashboard/v1/fixtures, copied here verbatim.
// They are real answers from Core, captured against a PostgreSQL by
// `__tests__/bandeja_de_atencion.test.js`, and that test compares them again on
// every run — so they cannot age in silence.
//
// With `VITE_COORDINATION_SOURCE=api` the same screens ask a running Core. That
// needs what the routes need and the demo cannot fake: a HUMAN SESSION (cookie
// `auth_token`), the double-submit CSRF for every write (cookie `csrf_token`
// repeated in `x-csrf-token`, already handled by core/network/api.js) and this
// origin listed in Core's `ALLOWED_ORIGINS`. An `mm_…` agent token answers 401
// on every one of these routes.

export const FIXTURES = 'fixtures';
export const API = 'api';

export const SOURCE = import.meta.env.VITE_COORDINATION_SOURCE === API ? API : FIXTURES;
export const onFixtures = SOURCE === FIXTURES;

const FILES = { atencion, controles, estado, historia, metricas };

// What each fixture sample answers, named as the file names it.
export const SAMPLES = {
    attention: ['atencion', 'bandeja'],
    attentionKind: ['atencion', 'una clase'],
    seats: ['estado', 'parrilla'],
    seat: ['estado', 'un puesto'],
    control: ['controles', 'estado deseado'],
    history: ['historia', 'historial'],
    snapshot: ['historia', 'instantánea'],
    taskMetrics: ['metricas', 'una tarea'],
    durations: ['metricas', 'agregado'],
};

// The sample's response, plus where it came from — the screens print the
// request line so nobody has to trust that the numbers match the route.
export function readSample(name) {
    const [file, sample] = SAMPLES[name];
    const found = FILES[file].samples.find(item => item.name === sample);
    if (!found) throw new Error(`El fixture ${file}.json no trae la muestra «${sample}»`);
    return { response: found.response, request: found.request, file: `${file}.json`, sample };
}

// The prose each fixture carries about its own family: what it answers and
// what it does NOT. Shown on its screen, because a demo that drops it invites
// exactly the reading the sentence was written to prevent.
export function familyAbout(file) {
    return FILES[file]?.about ?? null;
}

// Whether the interface exists yet. It does not, and every fixture says so.
export const interfaceStatus = FILES.atencion.interface;

// WHICH IDS THE FIXTURES CARRY. A sample answers for one seat, one task and one
// scope; asking for another one is not something this demo can answer, and it
// says so instead of showing the sample under the wrong name.
export const FIXTURE_SCOPE = {
    seatId: readSample('seat').response.seat.position_id,
    controlPositionId: readSample('control').response.control.position_id,
    taskId: readSample('taskMetrics').response.task.id,
    durationsFilters: readSample('durations').response.filters,
    attentionKind: 'reserva_perdida',
};
